module.exports = __webpack_public_path__ + "img/experts-video-image1.bd05130d.svg";